import React, { memo, ReactNode } from 'react';

import { General } from './General/General';
import { Requisites } from './Requisites/Requisites';
import { Customer } from '../../../types/dashboardInformation';
import { ErrorValidate } from '../useModalCustomer';

interface ModalBodyCustomerProps {
    form: Customer;
    onForm: (name: string, value: string) => void;
    errorValidate: ErrorValidate;
    isError?: boolean;
    activeTab: string;
}

export const ModalBodyCustomer = memo(
    ({ form, onForm, errorValidate, activeTab }: ModalBodyCustomerProps) => {
        const tabMapping: Record<string, ReactNode> = {
            general: <General form={form} onForm={onForm} errorValidate={errorValidate} />,
            requisites: <Requisites form={form} onForm={onForm} />,
        };

        return <form>{tabMapping[activeTab]}</form>;
    }
);
